import type { DocumentClass } from '@/api/(admin)/document-types/types';

/** The three document classes, in the order the old dashboard listed them. */
export const DOCUMENT_CLASSES: DocumentClass[] = [
  'COMPANY',
  'TRANSACTIONAL',
  'PRODUCT',
];

/**
 * Table state as the URL and `useTable` express it.
 *
 * `isDeprecated` is not optional. The route's querystring schema defaults it to
 * `false`, so omitting it does not mean "both" — it means active only. Holding
 * it explicitly keeps that from reading as an absent filter.
 */
export interface DocumentTypesQueryInput {
  page: number;
  limit: number;
  sort?: string | undefined;
  filters?: Record<string, string[]> | undefined;
  isDeprecated: boolean;
}

/** What the document-types querystring actually carries. */
export interface DocumentTypesParams {
  page: number;
  count: number;
  sort?: string;
  name?: string;
  description?: string;
  shortDescription?: string;
  impactAreaDescription?: string;
  documentClass?: DocumentClass | 'ALL';
  isDeprecated: boolean;
}

/** The create dialog's form state. */
export interface DocumentTypeFormValues {
  title: string;
  description: string;
  documentClass: DocumentClass;
  impactAreaId: string;
}
